 <template>
  <LayoutBaseContent class="max-w-4xl md:max-w-none">
    <div class="flex justify-center mt-4 md:mt-8">
      <WidgetAdvert shape="banner" isExpandable class="justify-center mx-2 md:mx-0 mb-8" />
    </div>


    <div class="md:grid grid-cols-12 gap-4">
      <div class="md:col-start-2 md:col-end-8 lg:col-start-2 lg:col-end-9 xl:col-start-4 xl:col-end-10">
        <RouterLink
          v-for="item in compPostItems"
          :key="item.title"
          tag="div"
          :to="item.to"
          class="cursor-pointer sm:mb-4 border-b border-gray-lightest sm:border-none post-card"
          :name="item.name"
        >
          <LayoutPanel class="post-card-content">
            <div class="container-padding">
              <div class="post-card-body">
                <div>
                  <h2 class="font-semibold text-lg sm:text-xl">{{ item.title }}</h2>

                  <p class="mb-0 pr-4 text-sm sm:text-base">{{ item.description }}</p>
                </div>

                <div class="post-card-icon">
                  <FontAwesomeIcon :icon="item.icon" />
                </div>
              </div>
            </div>
          </LayoutPanel>
        </RouterLink>
      </div>

      <WidgetAdvert shape="skyscraper" class="hidden md:block advert-container md:col-start-8 md:col-end-12 lg:col-start-9 lg:col-end-13 xl:col-start-10 xl:col-end-13" />
    </div>
  </LayoutBaseContent>
</template>

<script>
  import {faCow} from '@fortawesome/pro-regular-svg-icons'
  import displayLocation from '@/lib/mapping/display-location'
  import {allSpecies} from '@/lib/helpers/commodities'
  import LayoutBaseContent from '@/components/layout/LayoutBaseContent'
  import LayoutPanel from '@/components/layout/LayoutPanel'
  import WidgetAdvert from '@/components/widgets/WidgetAdvert'

  export default {
  name: 'Post',
  components: {
    LayoutBaseContent,
    LayoutPanel,
    WidgetAdvert
  },
  watch: {
    'appIs.finishedIntialLoad'(hasLoaded) {
      // Get draft listings ahead of time
      if (hasLoaded) {
        if (this.appIs.auth) {
          this.$store.dispatch('listing/getDrafts')
        }
      }
    },

    '$route.name'() {
      this.checkPostModalRequired()
    },

    // When Haulage or Finance modals close we need to redirect back to /post as they have no landing page
    '$store.state.modal.list'(newValue) {
      if (newValue.length === 0) {
        this.$router.push('/post').catch(() => {})
      }
    }
  },
  created() {
    if (this.appIs.auth) {
      this.$store.dispatch('listing/getDrafts')
    }

    this.$store.dispatch('adverts/get', {
      commoditySlug: 'livestock',
      categories: allSpecies,
      displayLocation: displayLocation.POST_LISTING_PAGE
    })

    this.checkPostModalRequired()
  },
  computed: {
    compPostItems() {
      return [
        {
          title: 'Post Listing',
          description: 'Create a Livestock, Feed & Bedding or Working Dogs listing',
          icon: faCow,
          to: '/post/listing',
          name: 'post-listing'
        }
      ]
    }
  },
  methods: {
    checkPostModalRequired() {
      if (this.$route.name === 'post-finance') {
        this.$modal.open('ModalFinanceEstimate')
      }
    }
  },
  head() {
    return {
      title: {
        inner: 'New Post'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.advert-container {
  width: 320px;
}

.post-card-body {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.post-card-content {
  width: 100%;
}

.post-card-icon {
  font-size: 4rem;
  width: 20%;
  text-align: center;
  margin-left: auto;
}

@media (min-width: 1024px) {
  .advert-container {
    max-width: 350px;
  }
}


@media (min-width: 1115px) {
  .advert-container {
    max-width: 400px;
  }
}
</style>
